import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import { Union } from "@/__main__/data-model.mjs";
import { ItemRarityEnum } from "@/game-fortnite/types/ItemRarity.mjs";

export const item = {
  name: String,
  key: String,
  // Derived from game-fortnite/components/ItemBox
  rarity: Union(Object.values(ItemRarityEnum)),
} satisfies ModelDefinition;

export type Item = FromModel<typeof item>;
